import AreaCascader from './area-cascader/index'
import AreaInfo from './area-info/index'
import CustomerBoard from './customer-board/index'
import DefaultImage from './default-image/index'
import ExportButton from './export-button/index'
import Hamburger from './Hamburger/index'
import IconSvg from './Icon-svg/index'
import ImportError from './import-error/index'
import LayoutPlatform from './layout-platform/index'
import PaginationBoard from './pagination-board/index'
import SetPermission from './set-permission/index'
import TreeCascader from './tree-cascader/index'
import TreeMenu from './tree-menu/index'
import UploadTemplate from './upload-template/index'
import MasterPage from './layout/masterPage.vue'
import TreeLeft from './tree-left/index'

const components = [
  AreaCascader,
  AreaInfo,
  CustomerBoard,
  DefaultImage,
  ExportButton,
  Hamburger,
  IconSvg,
  ImportError,
  LayoutPlatform,
  PaginationBoard,
  SetPermission,
  TreeCascader,
  TreeMenu,
  UploadTemplate,
  MasterPage,
  TreeLeft
]

export default {
  install: Vue => {
    components.map(component => {
      Vue.component(component.name, component);
    })
  }
}




// WEBPACK FOOTER //
// ./src/components/index.js